<template>
  <Page :page-name="pageName" :table="table" :pagination="pagination" :search-bar="searchBar">
    <div slot="operate-bar" class="operate-bar">
      <el-button type="primary" @click="jumpConfigPage()">添加</el-button>
    </div>
    <div slot="publishStatus" slot-scope="{scope}">
      <span>{{ scope.publishStatus | publishStatusFilter }}</span>
    </div>
    <template slot="table-operate" slot-scope="{scope}">
      <el-button type="text" @click="bannerMove(scope.id, 'up')">上移</el-button>
      <el-button type="text" @click="bannerMove(scope.id, 'down')">下移</el-button>
      <el-button v-if="[0, 2].includes(scope.publishStatus)" type="text" slot="reference" @click="jumpConfigPage(scope.id, 'publish')">发布</el-button>
      <el-button v-if="[1].includes(scope.publishStatus)" type="text" slot="reference" style="color: #f33458;" @click="bannerOperate(scope.id)">下架</el-button>
      <el-button v-if="[0, 2].includes(scope.publishStatus)" type="text" @click="jumpConfigPage(scope.id)">编辑</el-button>
      <el-button type="text" @click="jumpConfigPage(scope.id, 'look')">查看</el-button>
      <el-button v-if="[0, 2].includes(scope.publishStatus)" type="text" slot="reference" style="color: #f33458;" @click="bannerDelete(scope.id)">删除</el-button>
    </template>
  </Page>
</template>

<script>
// import moment from 'moment'
import Page from '@/components/Page.vue'
import { getBannerList, bannerOperate, bannerDelete, bannerMove } from '@/api/configPage'
const initParams = {
  current: 1,
  size: 10,
  title: '',
  status: ''
}

export default {
  components: {
    Page
  },
  filters: {
    publishStatusFilter (val) {
      switch (val) {
        case 0:
          return '未发布'
        case 1:
          return '已发布'
        case 2:
          return '已下架'
      }
    }
  },
  data () {
    return {
      params: {...initParams},
      pageName: 'Banner管理',
      table: {
        selection: false, // 是否开启选择框
        index: true,
        // disableKey: 'xxx', // 是否可勾选字段
        tableInfo: [{
          key: 'title',
          name: '标题',
          minWidth: 80
        }, {
          key: 'imgUrl',
          name: '图片',
          minWidth: 80,
          type: 'img',
          width: '70px',
          height: '40px'
        }, {
          key: 'publishTime',
          name: '发布时间',
          minWidth: 80
        }, {
          key: 'username',
          name: '增加人',
          minWidth: 80
        }, {
          key: 'updateTime',
          name: '增加时间',
          minWidth: 80
        }, {
          type: 'custom',
          key: 'publishStatus',
          name: '状态',
          minWidth: 80
        }],
        tableData: [],
        deleteList: (list) => {
          console.log(list)
        }
      },
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        currentChange: (page) => {
          this.searchType(page)
        },
        sizeChange: (pageSize) => {
          this.params.size = pageSize
          this.searchType()
        }
      },
      searchBar: {
        list: [{
          type: 'input',
          prop: 'title',
          label: '标题',
          placeholder: '请输入Banner标题'
        }, {
          type: 'select',
          prop: 'status',
          label: '状态',
          // valueKey: '',
          // labelKey: '',
          options: [{
            value: 0,
            label: '未发布'
          }, {
            value: 1,
            label: '已发布'
          }, {
            value: 2,
            label: '已下架'
          }],
          placeholder: '请选择Banner状态'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: (params) => {
            this.params = { ...this.params, ...params }
            this.searchType(1)
          }
        }, {
          type: 'btn',
          text: '重置',
          isReset: true,
          btnType: 'primary',
          callback: this.resetList
        }]
      }
    }
  },
  async mounted () {
    this.initData()
  },
  methods: {
    removeNullParam (params) {
      for (const key in params) {
        if (params[key] !== 0 && !params[key]) {
          delete params[key]
        }
      }
      return params
    },
    async initData () {
      const { data = {} } = await getBannerList(this.removeNullParam(this.params))
      const { records = [], total = 0 } = data
      this.$set(this.table, 'tableData', records)
      this.$set(this.pagination, 'total', total)
    },
    async bannerMove (id, type) {
      if (type === 'up') {
        await bannerMove({id, moveDirection: 1})
        this.$message.success('上移成功')
      } else {
        await bannerMove({id, moveDirection: 2})
        this.$message.success('下移成功')
      }
      this.searchType(this.params.current)
    },
    bannerOperate (id) {
      this.$confirm('确定要下架吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await bannerOperate({
          id,
          publishStatus: 2
        })
        this.$message.success('下架成功')
        this.searchType()
      }).catch(() => {

      })
    },
    bannerDelete (id) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await bannerDelete(id)
        this.$message.success('删除成功')
        this.searchType()
      }).catch(() => {

      })
    },
    searchType (page = 1) {
      if (page) this.pagination.currentPage = page
      this.params.current = page
      this.initData()
    },
    resetList () {
      this.params = {...initParams}
      this.searchType()
    },
    jumpConfigPage (id = '', type) {
      if (id) {
        if (type === 'publish') {
          this.$router.push(`/management-system/contentConfigPage?sourceType=1&id=${id}&type=publish`)
        } else if (type === 'look') {
          this.$router.push(`/management-system/contentConfigPage?sourceType=1&id=${id}&type=look`)
        } else {
          this.$router.push(`/management-system/contentConfigPage?sourceType=1&id=${id}`)
        }
      } else {
        this.$router.push('/management-system/contentConfigPage?sourceType=1')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button + .el-button{
  margin-left: 0;
}
</style>
